/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} ZoomInputs */

const en_zoom = /** @type {(inputs: ZoomInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zoom`)
};

const es_zoom = /** @type {(inputs: ZoomInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zoom`)
};

const fr_zoom = /** @type {(inputs: ZoomInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zoom`)
};

const de_zoom = /** @type {(inputs: ZoomInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zoomen`)
};

const ja_zoom = /** @type {(inputs: ZoomInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ズーム`)
};

const zh_zoom = /** @type {(inputs: ZoomInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`缩放`)
};

const ar_zoom = /** @type {(inputs: ZoomInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`تكبير`)
};

const id_zoom = /** @type {(inputs: ZoomInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Perbesar`)
};

const it_zoom = /** @type {(inputs: ZoomInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zoom`)
};

const ru_zoom = /** @type {(inputs: ZoomInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Масштаб`)
};

const pt_zoom = /** @type {(inputs: ZoomInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zoom`)
};

const ko_zoom = /** @type {(inputs: ZoomInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`확대/축소`)
};

/**
* | output |
* | --- |
* | "Zoom" |
*
* @param {ZoomInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const zoom = /** @type {((inputs?: ZoomInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<ZoomInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_zoom(inputs)
	if (locale === "es") return es_zoom(inputs)
	if (locale === "fr") return fr_zoom(inputs)
	if (locale === "de") return de_zoom(inputs)
	if (locale === "ja") return ja_zoom(inputs)
	if (locale === "zh") return zh_zoom(inputs)
	if (locale === "ar") return ar_zoom(inputs)
	if (locale === "id") return id_zoom(inputs)
	if (locale === "it") return it_zoom(inputs)
	if (locale === "ru") return ru_zoom(inputs)
	if (locale === "pt") return pt_zoom(inputs)
	return ko_zoom(inputs)
});